<template>
  <div class="container">
    <div class="logo">
      <img src="../assets/logo.png" alt="" />
    </div>
    <h1>404 Not Found</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.logo {
  margin: 60px 0 30px 0;
  text-align: center;
}

h1 {
  text-align: center;
}
</style>